import { AuditableResponse } from "../common/AuditableResponse"
import { InventoryTypeFieldValueDetails } from "../inventory_type/InventoryTypeFieldValueDetails"

export class InventoryItemDetails extends AuditableResponse {
  id: number
  isCoreProduct: boolean
  name: string
  price: number
  sku: string
  totalQuantityOnHand: number
  inventoryTypeId?: number
  inventoryTypeFieldValues: InventoryTypeFieldValueDetails[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, name?: string, isCoreProduct?: boolean, price?: number, sku?: string, totalQuantityOnHand?: number, inventoryTypeId?: number, inventoryTypeFieldValuesJson?: any, createdByUserJson?: any, createdDate?: string, lastModifiedByUserJson?: any, lastModifiedDate?: string) {
    super(createdByUserJson, createdDate, lastModifiedByUserJson, lastModifiedDate)
    this.id = id
    this.isCoreProduct = isCoreProduct ?? false
    this.name = name ?? ''
    this.price = price ?? 0
    this.sku = sku ?? ''
    this.totalQuantityOnHand = totalQuantityOnHand ?? 0
    this.inventoryTypeId = inventoryTypeId
    this.inventoryTypeFieldValues = inventoryTypeFieldValuesJson ? inventoryTypeFieldValuesJson as InventoryTypeFieldValueDetails[] : []
  }
}
